import {useTransition} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'

import {Props} from './TrustModal.types'

export function useTrustModal(props: Props) {
  const {fetchCardBoundContext} = props
  const t = useI18n()
  // key упущен намерено, иначе при повторных вызовах будет возвращаться урл предыдущей привязки
  // а когда придет новый урл, сработает unmount в хуке useCardBoundRef, который закроет модалку
  const [{payload: boundContext, isPending, error}, startTransition] = useTransition(() => fetchCardBoundContext())
  const translates = {
    repeat: t('phoenix.add_new_card.label', 'Повторить'),
    title: t('phoenix.add_new_card.title'),
    subtitle: t('phoenix.add_new_card.label'),
  } as const

  return {
    isPending,
    bindingType: boundContext?.bindingType,
    bindingUrl: boundContext?.bindingUrl,
    error,
    translates,
    updateHandler() {
      startTransition(fetchCardBoundContext)
    },
  } as const
}
